import { apiFetch } from "../../toolympus/api/core";
import { useCrudItem } from "../../toolympus/api/useSimpleCrud"
import { useSingleSchema } from "../../toolympus/hooks/useSchema";
import { useTranslationRecords } from "../Common/useTranslationRecords";
import { Page, PageApiPath } from "./usePageList"


export const usePageEdit = (id: string | number) => {
    const data = useCrudItem<Page>(`${PageApiPath}/${id}`, {
        defaultValue: {} as Page,
        returnPath: "/page",
    });

    const copyItem = () => {
        return apiFetch<Page>(
            `${PageApiPath}`,
            "post",
            {
                title: `${data.data.title} (copy)`,
                slug: `${data.data.slug}-copy`,
                content: data.data.content,
                lang: data.data.lang,
            });
    }

    const { schema } = useSingleSchema(`${PageApiPath}/uiconfig`);

    const translations = useTranslationRecords(data.data, { apiPath: PageApiPath, reload: data.reload });

    return {
        ...data,
        schema,
        copyItem,
        translations,
    }
}
